import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { AuthenticationService } from '../../../../core/authentication/Authentication.service';

import { User } from '../../../../core/authentication/user';
import { MatSnackBar } from '@angular/material';
import { url } from 'src/app/shared/urls/url';
import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss']
})
export class SignupComponent implements OnInit {
  Password: string;
  PasswordConfirm: string;
  Email: string;
  DisplayFirstName: string;
  DisplayLastFirstName: string;
  Error: string;
  DisplayFirstNameText;
  DisplayLastNameText;
  user: User = new User();
  plan: string;
  constructor(private router: Router,
    private auth: AuthenticationService,
    private _snackBar: MatSnackBar,
    private rutaActiva: ActivatedRoute,
    private http: HttpClient, private userUrl: url,
    private translate: TranslateService) {

  }

  ngOnInit() {
    this.translate.setDefaultLang(localStorage.getItem('language'));
  }

  Signup() {

    this.user.displayName = this.DisplayFirstNameText + " " + this.DisplayLastNameText;
    this.user.displayFirstName = this.DisplayFirstNameText;
    this.user.displayLastName = this.DisplayLastNameText;
    this.user.email = this.Email;

    this.auth.registerUser(this.user, this.Password).then((r) => {
      this.router.navigate(['/Thank-You']);
    }).catch((err) => {
      this._snackBar.open(err, 'Cerrar', {
        duration: 3000
      });
    });
  }
  onClickGoogleLogin() {
    this.auth.loginGoogle().then((r => {
      this.router.navigate(['/Thank-You']);
    })).catch((err) => {
      this._snackBar.open(err, 'Cerrar');
    })
  }
}
